import { Component, ElementRef, HostListener, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GooglePlacesService } from '../../services/google-places/google-places.service';

@Component({
  selector: 'app-multi-select-locations',
  templateUrl: './multi-select-locations.component.html',
  styleUrls: ['./multi-select-locations.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiSelectLocationsComponent),
    multi: true
  }]
})
export class MultiSelectLocationsComponent implements OnInit, ControlValueAccessor {
  @Input() dropdownItems: any[] = [];
  @Input() dropdownOnTop: boolean = false;
  @Input() placeHolder: string = "-- select countries --";
  @Input() googleLocations:boolean = false;


  dropdownVisible: boolean = false;
  selectedItems: any[] = [];
  filteredItems: any[] = [];
  searchTerm: string = '';

  constructor(private elementRef: ElementRef,private _googlePlacesService: GooglePlacesService ) {}

  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit() {
    
    this.filteredItems = [...this.dropdownItems];
  }

  writeValue(value: string[]): void {
    if (this.googleLocations) {
      this.selectedItems = value.map(val => ({
        name: val,
        code3: val
      }));
    }
    else
    this.selectedItems = this.dropdownItems.filter(item => value.includes(item.name));
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  filterItems() {
    if(this.googleLocations){
      this._googlePlacesService.getPlacePredictions(this.searchTerm, [], null)
        .then(predictions =>{
          this.filteredItems = predictions.map(a => ({
            ...a, 
            name: a.description ,// Add 'name' with 'description' value
            code3:a.description
          }));
        })
        .catch(error => {
          this.dropdownItems = []
        });
    }
    else{
    this.filteredItems = this.dropdownItems
      .filter(item => item.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
      .sort(this.sortItems.bind(this));
    }
  }

  isSelected(item: any): boolean {
    return this.selectedItems.some(selectedItem => selectedItem.name === item.name);
  }

  toggleSelection(item: any) {
    if (this.isSelected(item)) {
      this.selectedItems = this.selectedItems.filter(i => i.name !== item.name);
    } else {
      this.selectedItems.push(item);
    }
    this.filteredItems.sort(this.sortItems.bind(this));
    this.onChange(this.selectedItems.map(i => i.name));
  }

  removeItem(item: any) {
    this.selectedItems = this.selectedItems.filter(i => i.name !== item.name);
    this.filteredItems.sort(this.sortItems.bind(this));
    this.onChange(this.selectedItems.map(i => i.name));
  }

  toggleDropdown(event: MouseEvent) {
    this.dropdownVisible = !this.dropdownVisible;
    event.stopPropagation();
  }

  private sortItems(a: any, b: any): number {
    return this.isSelected(a) === this.isSelected(b) ? 0 : this.isSelected(a) ? -1 : 1;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target as HTMLElement)) {
      this.dropdownVisible = false;
    }
  }
}
